import { Controller } from "@hotwired/stimulus"

// Shared base for the client-side DataTables (static tables and export tables).
//
// Subclasses provide:
//   - `tableSelector`        the CSS selector of the <table> inside the controller element
//   - `datatableOptions(table)` the DataTables config (merged over `window.datatablesDefaults`)
//
// The lifecycle (init on connect, destroy on disconnect and before Turbo caches the
// page) is handled here once, instead of being copied into every controller.
export default class extends Controller {
  connect() {
    this._boundDestroy = () => this.destroyDatatable()
    this.initializeDatatable()
    document.addEventListener("turbo:before-cache", this._boundDestroy)
  }

  disconnect() {
    this.destroyDatatable()
    document.removeEventListener("turbo:before-cache", this._boundDestroy)
  }

  get tableSelector() {
    return ".datatables-basic"
  }

  datatableOptions() {
    return {}
  }

  initializeDatatable() {
    const table = $(this.element.querySelector(this.tableSelector))
    if (!table.length) return

    if ($.fn.DataTable.isDataTable(table)) {
      table.DataTable().destroy()
    }

    // Defaults first so that per-table options (e.g. a custom `language`) win.
    this.dataTable = table.DataTable({ ...window.datatablesDefaults, ...this.datatableOptions(table) })
  }

  destroyDatatable() {
    const table = $(this.element.querySelector(this.tableSelector))
    if ($.fn.DataTable.isDataTable(table)) {
      table.DataTable().destroy()
    }
  }
}

// Expands a collapsed responsive row into a Bootstrap modal listing every column.
// Built lazily (at init time) because `$.fn.dataTable` is not available when the
// controller modules are first evaluated.
export function responsiveModal() {
  return {
    details: {
      display: $.fn.dataTable.Responsive.display.modal({
        header: function(row) {
          return "Details of " + row.data()["full_name"]
        }
      }),
      type: "column",
      renderer: function(api, rowIdx, columns) {
        const data = $.map(columns, function(col) {
          return col.title !== "" // Do not show the row in the modal popup if the title is blank (e.g. checkbox column)
            ? '<tr data-dt-row="' + col.rowIdx + '" data-dt-column="' + col.columnIndex + '">' +
                "<td>" + col.title + ":</td> " +
                "<td>" + col.data + "</td>" +
              "</tr>"
            : ""
        }).join("")

        return data ? $('<table class="table"/>').append("<tbody>" + data + "</tbody>") : false
      }
    }
  }
}

// Strips the Bootstrap button-group styling DataTables adds around a collection button.
export function detachButtonGroup(api, node, _config) {
  $(node).removeClass("btn-secondary")
  $(node).parent().removeClass("btn-group")
  setTimeout(function() {
    $(node).closest(".dt-buttons").removeClass("dt-buttons").addClass("")
  }, 50)
}
